import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router'
import { ArrowLeft } from '@phosphor-icons/react'
import { PageMeta } from '@/app/PageMeta'
import type { PageRoute } from '@/app/routes'
import { PageHeader } from '@/components/page/PageHeader'
import { Mascot } from '@/components/brand/Mascot'
import { thankYouPage as t } from '@/content/contact'
import './contact.css'

/** /thank-you, ported from v1: the confirmation, then home after a short countdown. Never indexed. */
export function ThankYouPage({ page }: { page: PageRoute }) {
  const navigate = useNavigate()
  const [count, setCount] = useState(t.redirectSeconds)

  useEffect(() => {
    if (count <= 0) {
      navigate('/')
      return
    }
    const id = window.setTimeout(() => setCount((c) => c - 1), 1000)
    return () => window.clearTimeout(id)
  }, [count, navigate])

  return (
    <div className="pg">
      <PageMeta page={page} />
      <meta name="robots" content="noindex, follow" />
      <div className="ty-head">
        <PageHeader eyebrow={t.eyebrow} titleThin={t.titleThin} titleBold={t.titleBold} lede={t.lede}>
          <p className="pg-mono" aria-live="polite" aria-atomic="true">
            {t.redirecting} {count} second{count === 1 ? '' : 's'}
          </p>
          <Link to="/" className="pg-btn">
            <ArrowLeft size={15} weight="bold" aria-hidden />
            {t.home}
          </Link>
        </PageHeader>
        <Mascot pose="celebrate" height={140} bob eager className="ty-mascot" />
      </div>
    </div>
  )
}
